import type React from 'react';

import { SkeletonContainer } from 'src/app/pages/starterDashboardV2/shared/components';

import { PlatformCardSkeleton } from './components/PlatformCardSkeleton';

export const RecommendedGroupsCardLoadingVariant2: React.FC = () => {
	return (
		<div className="flex h-full w-full items-center justify-center gap-4">
			<SkeletonContainer loading>
				<PlatformCardSkeleton platform="reddit" placeholderColor="bg-icon-inverse-disabled" />
			</SkeletonContainer>
			<SkeletonContainer loading>
				<PlatformCardSkeleton platform="facebook" placeholderColor="bg-icon-inverse-disabled" />
			</SkeletonContainer>
		</div>
	);
};
